// Contact / WhatsApp configuration — SINGLE SOURCE OF TRUTH.
//
// Change ONLY this number and everything else (phone links, display
// formatting, WhatsApp links) updates automatically.
export const WHATSAPP_NUMBER = '212609373560'

// tel: link number (same as WhatsApp number).
export const PHONE_NUMBER = `+${WHATSAPP_NUMBER}`

// Human-readable display, e.g. +212 609-373560.
function formatPhoneDisplay(raw: string): string {
  if (raw.length >= 9) {
    return `+${raw.slice(0, 3)} ${raw.slice(3, 6)}-${raw.slice(6)}`
  }
  return `+${raw}`
}

export const PHONE_DISPLAY = formatPhoneDisplay(WHATSAPP_NUMBER)

// Build an api.whatsapp.com link for an optional message.
export function buildWhatsAppUrl(message?: string): string {
  const base = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`
  return message ? `${base}&text=${encodeURIComponent(message)}` : base
}